import React, { } from 'react'

import MaskedInput from 'react-text-mask'
import emailMask from 'text-mask-addons/dist/emailMask'
import urlMask from '../../../utils/functions/urlMask'

export const PhoneMask = (props) => {
  const { inputRef, ...other } = props

  return (
    <MaskedInput
      {...other}
      ref={(ref) => {
        inputRef(ref ? ref.inputElement : null)
      }}
      guide
      mask={['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
      placeholderChar='_'
      placeholder='(555) 495-3947'
    />
  )
}

export const EmailMask = (props) => {
  const { inputRef, ...other } = props

  return (
    <MaskedInput
      {...other}
      ref={(ref) => {
        inputRef(ref ? ref.inputElement : null)
      }}
      guide
      mask={emailMask}
      placeholderChar='_'
      placeholder='johndoe@gmail.com'
    />
  )
}

export const UrlMask = (props) => {
  const { inputRef, ...other } = props

  return (
    <MaskedInput
      {...other}
      ref={(ref) => {
        inputRef(ref ? ref.inputElement : null)
      }}
      guide
      mask={urlMask}
      placeholderChar='_'
      placeholder='www.google.com'
    />
  )
}
